<template>
  <div class>
    <div id="mainDiv" class="container roundedBorder secondary-bg primary-fg">
      <h2>Create a new account</h2>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <input
            v-on:keyup.enter="signupClicked"
            id="email"
            type="email"
            class="validate primary-fg"
          />
          <label for="email">Email</label>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <input
            v-on:keyup.enter="signupClicked"
            id="password"
            type="password"
            class="validate primary-fg"
          />
          <label for="password">Password</label>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <input
            v-on:keyup.enter="signupClicked"
            id="passwordConfirmation"
            type="password"
            class="validate primary-fg"
          />
          <label for="passwordConfirmation">Password confirmation</label>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <a
            class="waves-effect waves-light btn primary-bg right"
            v-on:click="signupClicked"
          >
            Create your account
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Signup",
  components: {},
  methods: {
    signupClicked: function() {
      let vueInstance = this;

      let em = document.getElementById("email").value;
      let pas = document.getElementById("password").value;
      let pas2 = document.getElementById("passwordConfirmation").value;

      //Check if every field is filled
      if (em == "" || pas == "" || pas2 == "") {
        alert("Please fill every field.");
        return;
      }

      if (pas != pas2) {
        alert("Passwords didn't match. Please reenter the passwords.");
        return;
      }

      // Signup the user.
      firebase
        .auth()
        .createUserWithEmailAndPassword(em, pas)
        .then(
          function() {
            var user = firebase.auth().currentUser;

            // Update successful.
            user
              .sendEmailVerification()
              .then(function() {
                // Email sent.
                alert(
                  "Successfully created your account, please check your email box to verify your account."
                );
                vueInstance.$router.push("/");
              })
              .catch(function(error) {
                // An error happened.
                alert(`Something went wrong: ${error.message}`);
              });
          },
          function(error) {
            // Handle Errors here.
            alert(`Something went wrong: ${error.message}`);
          }
        );
    }
  },
  metaInfo: {
    title: "Sign up",
    meta: [
      {
        name: "description",
        content:
          "Create a new account for LockerApp. LockerApp is a password manager that lets you protect the passwords of your social media accounts, email accounts, and much more, you can keep your notes secret as well. | LockerApp | Password Manager | Encrypted Passwords | Encrypted Notes | Generate a new strong password"
      },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {
        name: "keywords",
        content:
          "LockerApp, Signup, Sign up, Create an account, New account, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application"
      }
    ]
  }
};
</script>

<style scoped>
#mainDiv {
  padding: 20px;
}
</style>
